<script lang="ts">
    import {contactMenuId,personalData,personalContact} from "../../../store"
    import { Col} from "sveltestrap";
    import EditForm from "./EditForm.svelte";
    import ProfileMail from "./ProfileMail.svelte";
    let setContactMenuId:string
    contactMenuId.subscribe((value)=>{
      setContactMenuId = value
    })
    let setPersonalData:any
    personalData.subscribe((value)=>{
        setPersonalData = value
    })
    let setPersonalContact:number
    personalContact.subscribe((value)=>{
        setPersonalContact = value
    })
</script>
<Col xl="8" md="7" class="xl-50">
    {#if setPersonalData.length > 0}
        {#each setPersonalData as userItem ,index}
            <div class="tab-content d-block" id="v-pills-tabContent">
                <div class="tab-pane contact-tab-0 tab-content-child fade {setPersonalContact == index ?"active show" : ""}" id="v-pills-user" role="tabpanel" >
                    <ProfileMail userItem={userItem} index={index}/>
                </div>
            </div>
            <EditForm getId={index}/>
        {/each}
    {:else}
        <p>{'Sorry, Not Found Any Contact'}</p>
    {/if}
</Col>